import api from '@/api'
import { getNestedValue } from '@/utils/object.js'
import moment from 'moment'
import { normalizeIdentificationBacDetailsResponse } from '@/services/identification-service.js'

import APIUrls from '@/config/simpliciti-apis.js'
import {
  fetchBinCollection,
  formatResultSynthesis,
} from '@/api/identification-api.js'
import { normalizeBinCollectionItem } from '@/services/entities/bin-collection-entity'

export default {
  state: {
    identificationBacsSynthesis: [],
    identificationBacsDetails: [],
    identificationBacModal: {
      isOpen: false,
      data: {},
    },
    identificationBacSelected: null, // needed to jump to selected row in datatable from list
  },
  getters: {
    identificationBacsSynthesis: (state) => state.identificationBacsSynthesis,
    identificationBacsDetails: (state) => state.identificationBacsDetails,
    isIdentBacModalOpen: (state) => state.identificationBacModal.isOpen,
    identificationBacModalData: (state) => state.identificationBacModal.data,
    identificationBacSelected: (state) => state.identificationBacSelected,
  },
  mutations: {
    setIdentificationBacsSynthesis(state, data) {
      state.identificationBacsSynthesis = data
    },
    setIdentificationBacsDetails(state, data) {
      state.identificationBacsDetails = data
    },
    SET_IDENTIFICATION_BAC_MODAL(state, data) {
      state.identificationBacModal.isOpen = data
    },
    SET_IDENTIFICATION_BAC_MODAL_DATA(state, data) {
      state.identificationBacModal.data = data
    },
    resetIdentificationBacsSynthesis(state) {
      state.identificationBacsSynthesis = []
    },
    resetIdentificationBacsData(state) {
      state.identificationBacsDetails = []
    },
    setIdentificationBacSelected(state, data) {
      state.identificationBacSelected = data
    },
  },
  actions: {
    async getIdentificationBacModalDetails({ commit }, idOrItem) {
      let id = idOrItem.id || idOrItem
      let item = {}
      if (typeof idOrItem === 'object') {
        item = idOrItem
      }

      if (!id) {
        return
      }

      let results = {}

      await api.v3
        .get(`${APIUrls.APIV3_BIN_COLLECTIONS}/${parseInt(id)}`)
        .then((response) => {
          results = normalizeIdentificationBacDetailsResponse(response.data)
        })

      Object.assign(results, {
        item,
      })

      commit('SET_IDENTIFICATION_BAC_MODAL_DATA', results)

      return results
    },
    async fetchIdentificationBacsData(
      { commit, dispatch },
      { vehicleId, date }
    ) {
      let data = await fetchBinCollection(date, vehicleId, null, [
        'lift',
        'synthesis',
      ])
      let synthesisData = formatResultSynthesis(data)
      commit(
        'setIdentificationBacsSynthesis',
        synthesisData[0]?.synthesis || []
      )
      let items = getNestedValue(data, `0.vehicles.0.binCollections`, [])

      //Get vehicle from data
      let vehicle =
        data.length && data[0]['vehicles'].length
          ? data[0]['vehicles'][0].vehicle
          : {}
      if (Object.keys(vehicle).length === 0) return {}

      const leveesDetailsData = items
        .filter((item) => !!item.longitude && !!item.latitude)
        .map(function (item) {
          return normalizeBinCollectionItem(vehicle, item)
        })
      commit('setIdentificationBacsDetails', leveesDetailsData)

      dispatch(
        'simpliciti_map/setDataset',
        {
          type: 'identificationBacsMarkers',
          data: leveesDetailsData,
        },
        {
          root: true,
        }
      )
    },
    //Reset identification bacs methods
    async resetIdentificationBacsSynthesis({ commit }) {
      commit('resetIdentificationBacsSynthesis')
    },
    async resetIdentificationBacsData({ commit }) {
      commit('resetIdentificationBacsData')
    },
    setIdentificationBacSelected({ commit }, idIdentificationBac) {
      commit('setIdentificationBacSelected', idIdentificationBac)
    },
  },
}
